module.exports = __webpack_public_path__ + "static/media/band-dj-alt.df9b6d61.svg";